module.exports = __webpack_public_path__ + "static/Typewriter-857fa2a7d79b3b3e41d0617b64ebb706.png";